(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/pull', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/pull'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.pull, global.convert);
    global.pull = mod.exports;
  }
})(this, function (exports, _pull2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.pull = undefined;

  var _pull3 = _interopRequireDefault(_pull2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array removing all given values from the former array.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...*} values The values to remove.
   * @return {Object} Returns the updated object.
   * @example pull({ nested: { prop: [1, 2, 3, 1, 2, 3] } }, 'nested.prop', 1, 3) // => { nested: { prop: [2, 2] } }
   * @see {@link https://lodash.com/docs#pull|lodash.pull} for more information.
   * @since 0.2.0
   */
  var pull = (0, _convert.convert)(_pull3.default);
  exports.pull = pull;
  exports.default = pull;
});